
import { Component, Prop, Vue } from 'vue-property-decorator'

import QrInteroperableModel from '../models/QrInteroperable'

import EPaymentInfo from './PaymentInfo.vue'

@Component({
  components: {
    EPaymentInfo,
  },
})
export default class QrInteroperable extends Vue {
  @Prop({ required: true }) readonly qrInteroperable!: QrInteroperableModel
}
